// src/components/pages/UpdateEvent.js
import React, { useState, useEffect } from "react";
import { useHistory, useLocation, Link } from "react-router-dom";
import { updateEvent, getEventById } from "../../services/eventService";
import { getUserDetails } from "../../services/authService";
import "../../App.css";
import languageMap from "../languageMap";
import "./UpdateEvent.css";

export default function UpdateEvent() {
  const history  = useHistory();
  const location = useLocation();
  const state    = location.state || {};

  const eventId  = state.event_id || "";
  const username = state.username || localStorage.getItem("registeredUsername") || "0";
  const userId   = localStorage.getItem("user_id");

  const [userData,      setUserData]      = useState(null);
  const [eventName,     setEventName]     = useState(state.event_name      || "");
  const [eventType,     setEventType]     = useState(state.event_type      || "");
  const [introImageUrl, setIntroImageUrl] = useState(state.intro_image_url || "");
  const [eventDate,     setEventDate]     = useState(state.event_date      || "");
  const [eventLocation, setEventLocation] = useState(state.event_location  || "");
  const [error,         setError]         = useState(null);
  const [showPopup,     setShowPopup]     = useState(false);
  const [popupText,     setPopupText]     = useState("");

  const lang = languageMap.config.selectedLanguage || "en";
  const DEFAULT_AVATAR = "/icons/default_user.png";

  useEffect(() => {
    if (!eventId) return;
    getEventById(eventId)
      .then(data => {
        setEventName(data.event_name || "");
        setEventType(data.event_type || "");
        setIntroImageUrl(data.intro_image_url || "");

        let formattedDate = "";
        if (data.event_date) {
          const parts = data.event_date.split("-");
          if (parts.length === 3) {
            formattedDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
        }

        setEventDate(formattedDate);
        setEventLocation(data.event_location || "");
        setError(null);
      })
      .catch(err => {
        console.error(err);
        setError(languageMap.errorFetchingEvent?.[lang] || "Error fetching event");
      });
  }, [eventId, lang]);

  useEffect(() => {
    if (!userId) return;
    let cancel = false;
    (async () => {
      try {
        const res = await getUserDetails(userId);
        console.log(res);
        if (!cancel && res.success) {
          setUserData(res.user);
        }
      } catch (err) {
        console.error("Failed to fetch user:", err);
      }
    })();
    return () => { cancel = true; };
  }, [userId]);

  const handleUpdateEvent = async () => {
    try {
      let formattedDate = "";
      if (eventDate) {
        const d = new Date(eventDate);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        formattedDate = `${day}-${month}-${year}`;
      }

      await updateEvent(eventId, {
        event_name:      eventName,
        event_type:      eventType,
        intro_image_url: introImageUrl,
        event_date:      formattedDate,
        event_location:  eventLocation,
      });

      const eventItem = {
        event_id:        eventId,
        event_name:      eventName,
        event_type:      eventType,
        intro_image_url: introImageUrl,
        event_date:      formattedDate,
        event_location:  eventLocation,
        user_id:         username
      };

      history.push("/gallery-manager", { eventData: eventItem });
    } catch (err) {
      console.error(err);
      setError(languageMap.errorUpdatingEvent?.[lang] || "Error updating event");
    }
  };

  const popup      = txt => { setPopupText(txt); setShowPopup(true); };
  const closePopup = ()  => setShowPopup(false);

  const navigateHome = () => {
    const eventItem = {
      event_id:        eventId,
      event_name:      eventName,
      event_type:      eventType,
      intro_image_url: introImageUrl,
      event_date:      eventDate,
      event_location:  eventLocation,
      user_id:         username
    };
    history.push("/gallery-manager", { eventData: eventItem });
  };

  const handleBack = () => {
    history.goBack();
  };

  const handleUserClick = () => {
    if (!userId || !userData) return;
    history.push(`/user-details/${userId}`, {
      to_update: true,
      userData
    });
  };

  return (
    <div className="UpdateEvent">
      {/* top bar */}
      <div className="logo-container-top">
        <div className="logo-container-event">
          <img
            src="/icons/back.png"
            alt="Back"
            className="logo"
            onClick={handleBack}
            style={{ cursor: 'pointer' }}
          />
        </div>

        {userData?.management_type === "photographer" && (
          <div
            className="user-image-container-event"
            onClick={handleUserClick}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => e.key === "Enter" && handleUserClick()}
            style={{ cursor: "pointer" }}
          >
            <img
              src={userData?.photographer_profile?.image_url?.trim() || DEFAULT_AVATAR}
              alt="User"
              className="user-avatar"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = DEFAULT_AVATAR;
              }}
            />
          </div>
        )}

      </div>

      {/* form card */}
      <div className="UpdateEvent2">
        <div className="UpdateEventTitle">
          {languageMap.updateEventTitle[lang]}
        </div>

        <div className="form-container">
          {error && <p className="error-text">{error}</p>}

          <label>
            {languageMap.eventNameLabel[lang]}
            <input type="text" value={eventName} onChange={e => setEventName(e.target.value)} />
          </label>

          <label>
            {languageMap.eventDateLabel?.[lang] ?? "תאריך האירוע"}
            <input
              type="date"
              value={eventDate}
              onChange={e => setEventDate(e.target.value)}
            />
          </label>

          <label>
            {languageMap.eventTypeLabel?.[lang] ?? "סוג האירוע"}
            <input type="text" value={eventType} onChange={e => setEventType(e.target.value)} />
          </label>

          <label>
            {languageMap.eventLocationLabel?.[lang] ?? "מיקום האירוע"}
            <input type="text" value={eventLocation} onChange={e => setEventLocation(e.target.value)} />
          </label>

          <label>
            {languageMap.introImageLabel?.[lang] ?? "תמונה ראשית"}
            <input type="text" value={introImageUrl} onChange={e => setIntroImageUrl(e.target.value)} />
          </label>
        </div>

        <button className="circular-button update-btn" onClick={handleUpdateEvent}>
          {languageMap.updateEventButton[lang]}
        </button>
      </div>

      {/* bottom action bar */}
      <div className="action-bar-update-event">
        <button className="action-item-event" onClick={navigateHome}>
          <img src="/icons/home.png" alt="Home" className="action-icon-event" />
        </button>
      </div>

      {/* popup */}
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="popup-close-btn" onClick={closePopup}>×</button>
            <div className="popup-content">
              <img src="/icons/v.png"    alt="V"    className="v-icon"    />
              <span className="popupText">{popupText}</span>
              <img src="/icons/line_g.png" alt="line" className="line-icon" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
